<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from 'vue'
import PlayNextIcon from './svg/PlayNextIcon.vue'

export interface Emits {
  (e: 'onGoNext'): void
}

const props = defineProps({
  duration: {
    type: Number,
    required: true,
  },
})

const emits = defineEmits<Emits>()

const progress = ref(0)
const circumference = 2 * Math.PI * 16 // 半径调整为16

const circleStyle = ref({
  strokeDasharray: `${circumference} ${circumference}`,
  strokeDashoffset: circumference,
})

const timer = ref()

onMounted(() => {
  const interval = setInterval(() => {
    progress.value++
    const offset = circumference - (progress.value / props.duration) * circumference
    circleStyle.value.strokeDashoffset = offset

    if (progress.value >= props.duration) {
      emits('onGoNext')
      clearInterval(interval)
    }
  }, 1000)

  timer.value = interval
})

onUnmounted(() => {
  clearInterval(timer.value)
})

watch(() => props.duration, () => {
  progress.value = 0
  circleStyle.value.strokeDashoffset = circumference
})
</script>

<template>
  <div class="progress-container w-9 h-9">
    <svg class="progress-circle" width="36" height="36">
      <!-- 进度条的背景 -->
      <circle
        class="progress-ring__background"
        stroke="rgb(89, 89, 89)"
        stroke-width="2"
        fill="transparent"
        r="16"
        cx="18"
        cy="18"
      />
      <!-- 进度条的前景 -->
      <circle
        class="progress-ring__circle"
        stroke="#00c2f1"
        stroke-width="2"
        fill="transparent"
        r="16"
        cx="18"
        cy="18"
        :style="circleStyle"
      />
    </svg>
    <div class="icon-container">
      <play-next-icon />
    </div>
  </div>
</template>

  <style scoped>
  .progress-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .progress-circle {
    transform: rotate(-90deg);
  }
  .progress-ring__background,
  .progress-ring__circle {
    transition: stroke-dashoffset 0.35s;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }
  .icon-container {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  </style>
